import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import timeline from "./src/timeline.vue";
import timelineItem from "./src/timeline-item.vue";
export const xTimeline = withInstall(timeline, { timelineItem });
export default xTimeline;
export const xTimelineItem = withNoopInstall(timelineItem);
export * from "./src/timeline-item";
